import {inject} from '@angular/core';
import {CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {catchError, map, of, take} from 'rxjs';
import {ApiService} from '../../services/api.service';
import {environment} from '../../../environments/environment';

/**
 * - Quand environment.comingSoon est true : redirige toutes les routes vers /unavailable.
 * - Quand environment.comingSoon est false : la route /unavailable redirige vers l'accueil, les autres restent accessibles.
 * À placer sur toutes les routes sauf /unavailable.
 */
export const comingSoonGuard: CanActivateFn = (
  _route,
  state: RouterStateSnapshot
)=> {
  const router = inject(Router);
  const api = inject(ApiService);
  const url = state.url.split('?')[0];

  if (url === '/login/callback') {
    return true;
  }

  return api.getSiteAccessStatus().pipe(
    take(1),
    map((siteAccess) => {
      if (siteAccess.comingSoon && !siteAccess.accessible) {
        return url === '/unavailable' ? true : router.createUrlTree(['/unavailable']);
      }
      return url === '/unavailable' ? router.createUrlTree(['/']) : true;
    }),
    catchError(() => {
      if (environment.comingSoon) {
        return of(url === '/unavailable' ? true : router.createUrlTree(['/unavailable']));
      }
      return of(url === '/unavailable' ? router.createUrlTree(['/']) : true);
    })
  );
};

